import { render, staticRenderFns } from "./theme_switcher.vue?vue&type=template&id=b5b4d284&scoped=true"
import script from "./theme_switcher.vue?vue&type=script&lang=js"
export * from "./theme_switcher.vue?vue&type=script&lang=js"
import style0 from "./theme_switcher.vue?vue&type=style&index=0&id=b5b4d284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b4d284",
  null
  
)

export default component.exports